import { UserProfileInterface } from "@interfaces/index";
import {
  Button,
  MobileMenuItem,
  UserEditSvg,
  PasswordSvg,
  PhoneSvg,
  MailboxSvg,
  AlertCircleSvg,
  BriefcaseSvg,
  DevicesSvg,
  UserCheckSvg,
} from "@components/index";

export const MobileProfile = ({
  userInfo,
  onVerifyEmail,
}: {
  userInfo: UserProfileInterface;
  onVerifyEmail: () => void;
}) => (
  <div>
    <div className="pt-6 text-center">
      <div className="text-400 font-bold">{userInfo.fullName}</div>
      <div className="pt-1 font-light text-black-54 *:text-black-100">
        Client code: <span>{userInfo.clientCode}</span>
      </div>
    </div>
    {!userInfo.emailVerified && (
      <div className="mt-6 flex items-center justify-between gap-x-4 rounded-lg bg-black-8 px-4 py-2">
        <div className="text-200">
          Your Email is not verified, please verify you Email.
        </div>
        <Button height="small" title="Verify" onClick={() => onVerifyEmail} />
      </div>
    )}
    <div className="flex flex-col gap-y-4 pt-6">
      <MobileMenuItem href="/profile/change-name" icon={<UserEditSvg />}>
        <div>
          <div className="font-bold">Name</div>
          <div className="text-100 font-light text-black-54">
            {userInfo.fullName}
          </div>
        </div>
      </MobileMenuItem>
      <MobileMenuItem href="/profile/change-password" icon={<PasswordSvg />}>
        <div className="font-bold">Password</div>
      </MobileMenuItem>
      <MobileMenuItem href="/profile/change-phone" icon={<PhoneSvg />}>
        <div>
          <div className="font-bold">Phone</div>
          <div className="text-100 font-light text-black-54">
            {userInfo.phone}
          </div>
        </div>
      </MobileMenuItem>
      <MobileMenuItem
        href="#"
        icon={<MailboxSvg />}
        rightIcon={<AlertCircleSvg />}
        notLink
      >
        <div>
          <div className="font-bold">Email</div>
          <div className="text-100 font-light text-black-54">
            {userInfo.email}
          </div>
        </div>
      </MobileMenuItem>
      <MobileMenuItem href="/profile/my-businesses" icon={<BriefcaseSvg />}>
        <div>
          <div className="font-bold">My Businesses</div>
          <div className="text-100 font-light text-black-54">
            {userInfo.businesses}
          </div>
        </div>
      </MobileMenuItem>
      <MobileMenuItem href="/profile/red-statement" icon={<UserCheckSvg />}>
        <div className="font-bold">RED Statement</div>
      </MobileMenuItem>
      <MobileMenuItem href="/profile/leave" icon={<DevicesSvg />}>
        <div className="font-bold">Leave FBTC</div>
      </MobileMenuItem>
    </div>
  </div>
);
